import React, { useState } from "react";
import { Form, message, Divider, Upload } from "antd";
import {
  SaveButton, CancelButton, ModalComponent, trans,
  TableComponent, ButtonComponent

} from "@comps/components"
import { makeRequestStateless } from "@utils/helpers";
import { importEmployeeDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import { getErrorColumns } from "@comps/commonFunctions";
const langKey = Const["employee"].lngKey
const formName = "ImportEmployees";

const ImportEmployees = (props) => {

  const [saving, setSaving] = useState(false)
  const [childComponent, setChildComponent] = useState(null)
  const [hasErrors, setHaserrors] = useState(false);
  const onSubmit = (data) => {
    let file = null
    if (data.file_attachment === undefined) {
      message.info("Please Select File To Import!")
      return
    }
    if (data.file_attachment !== undefined) {
      file = data.file_attachment.fileList.length > 0 ? data.file_attachment.file : null
    }
    const payload = { file_attachment: file, employees_import: { attachment: { removed: false, org_name: file.name, key: "attachment" } } };
    makeRequestStateless(importEmployeeDataReq, payload, onSuccess, onError);
    setSaving(true);
  }

  const getMessage = (message) => {
    if (message.includes("out of bounds")) {
      const matches = [...message.matchAll(/\[(.*?)\]/g)];
      if (matches.length > 0) {
        const sheetname = matches.map(match => match[1]);
        return "Sheet not found.create or update sheet name to " + sheetname;
      } else {
        return message;
      }
    }
    return message;
  }
  const errorColumns = [
    {
      key: 'row',
      title: "Row",
      dataIndex: "row",
    },
    {
      key: 'column',
      title: "Column",
      dataIndex: "column",
    },
    {
      key: 'value',
      title: "Value",
      dataIndex: "value",
    },
    {
      key: 'message',
      title: "Message",
      render: (record) => (
        getMessage(record.message)
      ),
    },
  ]

  const onSuccess = (data, res) => {

    if (data && data.length && data.length > 0) {

      setHaserrors(true)
      setChildComponent(
        <>
          <Divider className="text-danger">Importing Errors</Divider>

          <TableComponent
            scroll={ { x: 'max-content', y: 'max-content' } }
            columns={ errorColumns }
            dataSource={ data }
            pagination={ false }
          />

        </>
      )
      setSaving(false)
      return;
    }
    setSaving(false)
    if (data && data.errors && data.errors.length !== undefined && data.errors.length === 0) {
      message.success(res.message);
      props.onCompleted(null)
      setChildComponent(null)
      setHaserrors(false)
      props.onSuccess()
    }
    if (data.errors !== undefined && data.errors.length > 0) {
      setHaserrors(true)
      setChildComponent(
        <>
          <Divider className="text-danger">Importing Errors</Divider>

          <TableComponent
            scroll={ { x: 'max-content', y: 'max-content' } }
            columns={ errorColumns }
            dataSource={ data.errors }
            pagination={ false }
          />

        </>
      )
    }
  }


  const onError = (err, res) => {
    setHaserrors(true)
    setSaving(false)
    setChildComponent(null);
    message.error('Server Side Error!');
    if (res.response !== undefined) {
      message.error(res.response.data.message);
    }
  }

  //============uploading file============
  const [fileList, setFileList] = useState([]);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  //=========================================

  const footer = [
    fileList.length > 0 &&
    <SaveButton form={ formName } key="create_button" htmlType="submit" loading={ saving } />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 50 } width={ 900 } maskClosable={ false }
      mainTitle={ trans(Commons.view) } subTitle={ trans(`${langKey}.import`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>

      <Form name={ formName } onFinish={ onSubmit }>

        <Form.Item name="file_attachment" rules={ rules.file_attachment } label={ trans(`${langKey}.file_attachment`) }
          className="da-mb-16"
          size="small"
        >
          <Upload
            accept=".xlsx"
            listType="picture"
            fileList={ fileList }
            onChange={ onChange }
            //onPreview={ onPreview }
            multiple={ false }
            beforeUpload={ (file) => {
              return false;
            } }
          >
            { fileList.length === 1 ? null : <ButtonComponent text="Upload" /> }
          </Upload>
        </Form.Item>
      </Form>

      { childComponent }
    </ModalComponent>
  )
}

export default ImportEmployees


const rules = {
  file_attachment: [
    { required: true, message: trans(`${langKey}.file_attachment`) },
  ],

};